import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M17 9V18" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 6V18" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 12L7 18" })
	]
});
const ForwardRef = forwardRef(SvgBarChart);
export default ForwardRef;
